module.exports = __webpack_public_path__ + "img/device-guide.81adfb70.png";